import { faker } from '@faker-js/faker'

import { getTreatmentCategory } from './TreatmentCategory'
import { getTreatmentTime } from './TreatmentTime'

import { TargetLanguage } from '../../contracts/service-offer'
import { AdminTreatmentStatus, AdminTreatmentView, OperationType } from '../../contracts/treatment'
import { asBuilder } from '../asBuilder'

export const getAdminTreatmentView = asBuilder((): AdminTreatmentView => {
  return {
    id: faker.number.int(),
    treatmentGroups: faker.helpers.multiple(getTreatmentCategory),
    names: faker.helpers.multiple(
      () => ({
        language: faker.helpers.enumValue(TargetLanguage),
        value: faker.lorem.word(),
      }),
      { count: 3 },
    ),
    type: faker.helpers.enumValue(OperationType),
    status: faker.helpers.enumValue(AdminTreatmentStatus),
    concerns: faker.helpers.multiple(getTreatmentCategory),
    similarTreatments: faker.helpers.multiple(getTreatmentCategory),
    recommendedTreatments: faker.helpers.multiple(getTreatmentCategory),
    descriptions: {
      recommendedTimes: faker.number.int(),
      procedureTime: getTreatmentTime(),
      recommendedCycle: getTreatmentTime(),
      effectOnSetPeriod: getTreatmentTime(),
      durationPeriod: getTreatmentTime(),
      downtime: getTreatmentTime(),
      anesthesia: faker.helpers.multiple(() => faker.lorem.word()),
      translatedDescriptions: faker.helpers.multiple(
        () => ({
          language: faker.helpers.enumValue(TargetLanguage),
          description: faker.lorem.sentence(),
          pros: faker.lorem.sentence(),
          cons: faker.lorem.sentence(),
          painDescription: faker.lorem.sentence(),
          sideEffect: faker.lorem.sentence(),
          caution: faker.lorem.sentence(),
        }),
        { count: 3 },
      ),
    },
    properties: {
      unitProperty: {
        id: faker.string.uuid(),
        name: faker.lorem.word(),
        comparisonBaseValue: faker.number.int(),
      },
      priceProperties: faker.helpers.multiple(() => ({
        id: faker.string.uuid(),
        sequentialId: faker.number.int(),
        name: faker.lorem.word(),
        multipleValuesAllowed: faker.datatype.boolean(),
        values: faker.helpers.multiple(() => ({
          id: faker.string.uuid(),
          sequentialId: faker.number.int(),
          name: faker.lorem.word(),
        })),
      })),
    },
  }
})
